/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import EventDetail from '../model/EventDetail';
import IsEnabledResponse from '../model/IsEnabledResponse';
import SimpleEvent from '../model/SimpleEvent';
import UrlObject from '../model/UrlObject';

/**
* Events service.
* @module api/EventsApi
* @version 1.0
*/
export default class EventsApi {

    /**
    * Constructs a new EventsApi. 
    * @alias module:api/EventsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Fetch an event detail
     * @param {String} uuid Filter by uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/EventDetail} and HTTP response
     */
    appHttpControllersEventDetailWithHttpInfo(uuid) {
      let postBody = null;
      // verify the required parameter 'uuid' is set
      if (uuid === undefined || uuid === null) {
        throw new Error("Missing the required parameter 'uuid' when calling appHttpControllersEventDetail");
      }

      let pathParams = {
        'uuid': uuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = EventDetail;
      return this.apiClient.callApi(
        '/api/v1/user_events/eventDetails/{uuid}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Fetch an event detail
     * @param {String} uuid Filter by uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/EventDetail}
     */
    appHttpControllersEventDetail(uuid) {
      return this.appHttpControllersEventDetailWithHttpInfo(uuid)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Check if event must be shown in my account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/IsEnabledResponse} and HTTP response
     */
    appHttpControllersEventGetEnabledEventsWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = IsEnabledResponse;
      return this.apiClient.callApi(
        '/api/v1/user_events/isEnabled', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Check if event must be shown in my account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/IsEnabledResponse}
     */
    appHttpControllersEventGetEnabledEvents() {
      return this.appHttpControllersEventGetEnabledEventsWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get youtube url
     * @param {String} uuid Filter by uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UrlObject} and HTTP response
     */
    appHttpControllersEventGetUrlWithHttpInfo(uuid) {
      let postBody = null;
      // verify the required parameter 'uuid' is set
      if (uuid === undefined || uuid === null) {
        throw new Error("Missing the required parameter 'uuid' when calling appHttpControllersEventGetUrl");
      }

      let pathParams = {
        'uuid': uuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UrlObject;
      return this.apiClient.callApi(
        '/api/v1/user_events/getUrl/{uuid}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get youtube url
     * @param {String} uuid Filter by uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UrlObject}
     */
    appHttpControllersEventGetUrl(uuid) {
      return this.appHttpControllersEventGetUrlWithHttpInfo(uuid)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Fetch all present and future events
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/SimpleEvent>} and HTTP response
     */
    appHttpControllersEventListWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [SimpleEvent];
      return this.apiClient.callApi(
        '/api/v1/user_events/getNextEvents', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Fetch all present and future events
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/SimpleEvent>}
     */
    appHttpControllersEventList() {
      return this.appHttpControllersEventListWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Fetch all past events
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/SimpleEvent>} and HTTP response
     */
    appHttpControllersEventListPastWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [SimpleEvent];
      return this.apiClient.callApi(
        '/api/v1/user_events/getPastEvents', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Fetch all past events
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/SimpleEvent>}
     */
    appHttpControllersEventListPast() {
      return this.appHttpControllersEventListPastWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Create a new reminder
     * @param {String} uuid Filter by uuid
     * @param {String} minutes Minutes of the remind
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/EventDetail} and HTTP response
     */
    appHttpControllersEventSetRemindWithHttpInfo(uuid, minutes) {
      let postBody = null;
      // verify the required parameter 'uuid' is set
      if (uuid === undefined || uuid === null) {
        throw new Error("Missing the required parameter 'uuid' when calling appHttpControllersEventSetRemind");
      }
      // verify the required parameter 'minutes' is set
      if (minutes === undefined || minutes === null) {
        throw new Error("Missing the required parameter 'minutes' when calling appHttpControllersEventSetRemind");
      }

      let pathParams = {
        'uuid': uuid,
        'minutes': minutes
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = EventDetail;
      return this.apiClient.callApi(
        '/api/v1/user_events/createReminder/{uuid}/{minutes}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create a new reminder
     * @param {String} uuid Filter by uuid
     * @param {String} minutes Minutes of the remind
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/EventDetail}
     */
    appHttpControllersEventSetRemind(uuid, minutes) {
      return this.appHttpControllersEventSetRemindWithHttpInfo(uuid, minutes)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
